import { FC, ReactElement } from 'react';
import styles from './Drawer.module.scss';
import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import { SelectBox, TextBox } from 'devextreme-react';
import * as React from 'react';
import { Button, } from 'devextreme-react/button';
import { Properties } from 'devextreme/ui/button';
import { Option } from '../Select/Select';

type DrawerAction = Properties & {
    mrAuto?: boolean;
}
type DrawerProps = {
    title?: string
    body?: ReactElement | null
    actions?: DrawerAction[]
}

export const Drawer: FC<{actions?: any[]; children?: any; title?: string;}> = observer(({ actions, children, title}) => {
    // const context = useContext(AppStoreContext);
    // if (!context.drawerStore.drawer) return null;
    // const { body, actions, children } = context.drawerStore.drawer;
    return (
        <div className={styles.wrapper}>
            <div className={styles.body}>
                <div className={styles.header}>
                    <div className={styles.headerText}>{title}</div>
                </div>
                <div className={styles.content}>
                    {children}
                </div>
                <div className={styles.footer}>
                    {actions?.map((props: any) => {
                        const { text, mrAuto, ...rest } = props;
                        return <Button key={text} text={text} className={mrAuto ? styles.left : ''} {...rest}/>;
                    })}

                </div>
            </div>
        </div>
    );
});
type DrawerTextProps = {
    label: string,
    value?: string,
    isReadOnly?: boolean
    onValueChange: (value: string) => void
}
export const DrawerTextField: FC<DrawerTextProps> = ({ label, value, isReadOnly, onValueChange }) => {
    return (
        <>
            <div className="dx-field">
                <div className="dx-field-label">{label}</div>
                {isReadOnly ?
                    <div className="dx-field-value-static">{value}</div> :
                    <TextBox className="dx-field-value" defaultValue={value} onValueChange={onValueChange}/>}
            </div>
        </>
    );
};

type DrawerDropProps = DrawerTextProps & {
    items: Option[]
}

export const DrawerDropField: FC<DrawerDropProps> = ({ onValueChange, items, label, value, isReadOnly }) => {

    return (
        <>
            <div className="dx-field">
                <div className="dx-field-label">{label}</div>
                {isReadOnly ?
                    <div className="dx-field-value-static">{value}</div> :
                    <SelectBox
                        className="dx-field-value"
                        displayExpr="label"
                        valueExpr="value"
                        disabled={items.length < 2}
                        defaultValue={value}
                        onValueChanged={e => {
                            onValueChange(e.value);
                        }}
                        items={items}
                    />
                }
            </div>
        </>
    );
};

export class DrawerStore {
    public drawer: DrawerProps | null = null;

    constructor () {
        makeAutoObservable(this);
    }

    public showDrawer (drawer: DrawerProps) {
        this.drawer = drawer;
    }

    public hideDrawer () {
        this.drawer = null;
    }
}